export default [
	{
		key: 'weekly',
		length: 7,
		name: '1 Week',
		binWidth: 1
	},
	{
		key: 'biweekly',
		length: 14,
		name: '2 Weeks',
		binWidth: 1
	},
	{
		key: 'monthly',
		length: 30,
		name: '1 Month',
		binWidth: 2
	},
	{
		key: 'quarterly',
		length: 90,
		name: '3 Months',
		binWidth: 7
	}
]
